import React from 'react'
import { Helmet } from 'react-helmet'
// import LoginComponents from '../../components/Login/login.components'
import LoginComponents from '../../components/Login/loginv2'
const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Login | AXONS PROJECT</title>
      </Helmet>
      <LoginComponents />
    </>
  )
}

export default LoginPage
